document.addEventListener('DOMContentLoaded', function() {
  // Initialize product preview toggles
  const previewToggles = document.querySelectorAll('.product-preview-toggle');
  
  previewToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const wrapper = this.closest('.product-item__image-wrapper');
      const previewInfo = wrapper.querySelector('.product-preview-info');
      
      // Toggle expanded state
      this.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        // Hide preview info
        previewInfo.setAttribute('aria-hidden', 'true');
        wrapper.classList.remove('show-preview-info');
      } else {
        // Show preview info
        previewInfo.setAttribute('aria-hidden', 'false');
        wrapper.classList.add('show-preview-info');
        
        // Close any other open previews
        document.querySelectorAll('.product-item__image-wrapper.show-preview-info').forEach(otherWrapper => {
          if (otherWrapper !== wrapper) {
            const otherToggle = otherWrapper.querySelector('.product-preview-toggle');
            const otherPreview = otherWrapper.querySelector('.product-preview-info');
            
            if (otherToggle && otherPreview) {
              otherToggle.setAttribute('aria-expanded', 'false');
              otherPreview.setAttribute('aria-hidden', 'true');
              otherWrapper.classList.remove('show-preview-info');
            }
          }
        });
      }
    });
  });
  
  // Close all previews when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-item__image-wrapper--has-preview')) {
      document.querySelectorAll('.product-item__image-wrapper.show-preview-info').forEach(wrapper => {
        const toggle = wrapper.querySelector('.product-preview-toggle');
        const previewInfo = wrapper.querySelector('.product-preview-info');
        
        if (toggle && previewInfo) {
          toggle.setAttribute('aria-expanded', 'false');
          previewInfo.setAttribute('aria-hidden', 'true');
          wrapper.classList.remove('show-preview-info');
        }
      });
    }
  });
});